export enum BusinessUnitKey {
  Flokee = 'FLOKEE',
  Cleepo = 'CLEEPO',
}

export const DEFAULT_DASHBOARD_ROUTE_NAME = 'DashboardView';
export const DEFAULT_LOGIN_ROUTE_NAME = 'AuthLoginView';
export const DEFAULT_SELECT_ACCOUNT_ROUTE_NAME = 'SelectAccountView';
export const DEFAULT_INVEST_ROUTE_NAME = 'InvestView';

export interface BusinessUnitSupportPhone {
  // Region shown next to the "Customer support" label, e.g. "Argentina".
  region: string;
  // `tel:` href, kept verbatim: it is not always the display label.
  telHref: string;
  // Display label for the number.
  label: string;
}

export interface BusinessUnitConfig {
  key: BusinessUnitKey;
  // Position in listings that show every product, e.g. the BU chooser.
  order: number;
  label: string;
  // Route prefix for this BU namespace (e.g. /flokee).
  basePath: string;
  // Production domain that implies this BU.
  domain?: string;
  // Route name to redirect authenticated users to this BU dashboard.
  dashboardRouteName: string;
  // Route name to redirect unauthenticated users to this BU login.
  loginRouteName: string;
  // Route name for account/order switcher view in this BU.
  selectAccountRouteName: string;
  // Route name for the BU invest page (free-plan redirect).
  investRouteName: string;
  // Help center URL for this BU (shown in sidebar support links when available).
  helpCenterUrl?: string;
  // Public product site for this BU, linked from the "About <product>" footer.
  websiteUrl: string;
  // Website row of the support drawer. Separate from `websiteUrl` because a
  // product operated by another company can point support at that company's
  // site while its own product site is somewhere else.
  supportWebsiteUrl: string;
  // Support email for this BU.
  supportEmail: string;
  // Support phone rows for this BU. Omit when the BU has none.
  supportPhones?: BusinessUnitSupportPhone[];
  // Privacy policy URL for this BU.
  privacyPolicyUrl: string;
  // WhatsApp support link for this BU.
  supportWhatsappUrl: string;
  // WhatsApp support phone label for this BU.
  supportWhatsappLabel: string;
  // WhatsApp numbers this product uses for accounts in specific countries,
  // keyed by ISO country code. Omit when one number serves every country.
  supportWhatsappByCountry?: Record<string, { phone: string; label: string }>;
  // Whether the BU requires a plan-subscription-approval modal before checkout.
  hasPlanSubscriptionApproval: boolean;
  // i18n key for the BU description on the chooser page.
  chooserDescriptionKey: string;
  /** i18n key prefix for cart plan selection (keys: .title, .description, .disclaimer). */
  cartSelectI18nPrefix: string;
  // Orbit entity kind for admin deep links.
  orbitEntityType: 'ecommerce' | 'project';
  // Orbit path template for admin deep links.
  orbitPathTemplate: string;
  // Shared UI assets resolved by BU.
  logoPath: string;
  faviconPath: string;
}
